import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=071db51c&scoped=true"
import script from "../../assets/ts/extend/extend.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/extend/extend.ts?vue&type=script&lang=ts&external"
import style0 from "./invitation.vue?vue&type=style&index=0&id=071db51c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071db51c",
  null
  
)

export default component.exports